import { SupportedCountryCodeDto } from 'api/v1/data-contracts';

import { IdLabelDto } from '../Common/IdLabelDto';

export const mapSupportedCountryCodeToIdLabelCountry = (
	supportedCountryCode: SupportedCountryCodeDto
): IdLabelDto => ({
	id: supportedCountryCode.shortCountryCode,
	label: supportedCountryCode.countryName,
});
